import React, { useState, useEffect } from 'react';
import SingleContractInstallment from './singlecontractinstallment';
import axios from 'axios';
import ConvertNumber from '../components/ConvertNumber';
import { API_URL } from '../config';
import logo_pop from '../assets/images/logo-pop.png';

var participantBuilding = '';
var participantCity = '';
var participantEmail = '';
var participantFirstName = '';
var participantFlat = '';
var participantLastName = '';
var participantPesel = '';
var participantPhone = '';
var participantPostalCode = '';
var participantStreet = '';
var contractSygnature = localStorage.getItem('contractSygnature')
let today = new Date();
let date;
if(parseInt(today.getMonth() + 1)< 10){
    date = today.getDate() + '-0' + parseInt(today.getMonth() + 1) + '-' + today.getFullYear();
}else{
    date = today.getDate() + '-' + parseInt(today.getMonth() + 1) + '-' + today.getFullYear();
}

const AppContractsRefresh = ({
    ready,
    getGroup,
    singData,
    users,
    payForm,
    dateToBay,
    usersParticipant,
    coursesHeadings,
    payZero,
    numberOfinstallments,
    entryFee,
    contrctSignature,
    allInstallments,
    allInstallmentsPrice,
    promotionsData
}) => {
    const userGetURL = `${API_URL}UserGet`;
    const getPriceByCourseHeadingsIdURL = `${API_URL}GetPriceByCourseHeadingsID`;
    const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
    const [formData] = useState({
        coursesHeadingsID: `${localStorage.getItem('coursesHeadingsID')}`,
        startDate: `${localStorage.getItem('startDate')}`,
        current_LocalizationsID: -1,
    });
    const [res, setRes] = useState([]);

    function paymentsMetod(method) {

        if (method.periodsOfValidityDVID === 1) {
            if(method.paymentTypesDVID === 1){
                return 'Roczna z góry'
            }else{
                return 'Roczna ratalna'
            }
            
        } else
            if (method.periodsOfValidityDVID === 2) {
                if(method.paymentTypesDVID === 1){
                    return 'Semestralna z góry'
                }else{
                    return 'Semestralna ratalna'
                }
                
            } else
                if (method.periodsOfValidityDVID === 3) {
                    return 'Miesięczna '+ method.paymentDVIDName
                }
        return ''
    }
    function perioridOFPayment(method){
        if(method.paymentTypesDVID === 1){
            return 'Z góry '
        }else{
            return 'Ratalna'
        }
    }
    function replaceFormatData(data){
        let newFormat;
        if(data.split("-").length != 2){
        newFormat = data.split("-")[2]+"."+data.split("-")[1]+"."+data.split("-")[0]}
        else{
            newFormat = data
        }
        return newFormat
    }

    useEffect(() => {
        axios
            .get(userGetURL, config)
            .then((response) => {
       
                participantBuilding = response.data.building;
                participantCity = response.data.city;
                participantEmail = response.data.email;
                participantFirstName = response.data.firstName;
                participantFlat = response.data.flat;
                participantLastName = response.data.lastName;
                participantPesel = response.data.pesel;
                participantPhone = response.data.phone;
                participantPostalCode = response.data.postalCode;
                participantStreet = response.data.street;
                setRes(allInstallments);
                // axios
                //     .post(getPriceByCourseHeadingsIdURL, formData, config)
                //     .then((response) => {
                //         const prodID = localStorage.getItem('productsID');
                //         let data = response.data.body;
                //         let item = data.find((e) => Number(e.productsID) === Number(prodID));
                       
                        
                //         {console.log('r1111232es')} 
                //         {console.log(res)} 
                //     })
                //     .catch(function (error) {
                //         console.log('post error', error);
                //     });
            })
            .catch(function (error) {
                console.log('get error response', error);
            });
    }, []);

    return getGroup ? (
        <>
            {/* <div>
                <button onClick={() => onCountClick()}>click</button>
            </div> */}
            <div className="generated-contract">
                <div className="partPdfImg">
                    <div className="contractLogoWraper">
                    <img src={logo_pop} alt="Logo Egurrola Dance Studio" className="generated-contract__logo" />
                    </div>
                   <div className="tittleContract"> 
                        <h1><strong>Wzór umowy uczestnictwa w zajęciach:</strong> </h1>
                        <h2><strong>
                            {ready?contrctSignature:"Nr/YZ"}
                            </strong>
                        </h2>
                    </div>
                    <div className="singinContractDay">zawarta w dniu {ready?replaceFormatData(singData):date} w Warszawie pomiędzy:</div>
                </div>

                <div className="partPdf">
                    <p className="generated-contract__intro">
                        
                        {coursesHeadings.clientsCyti ? coursesHeadings.clientsCyti : ''} pomiędzy{' '}
                        {coursesHeadings.contractHeader ? coursesHeadings.contractHeader : ''} ,
                        zwanym dalej<strong> "EDS"</strong>, a <strong>Klientem</strong>:
                    </p>
                </div>
                <div className="generated-contract__line"></div>
                <div className="partPdf">
                    {/* Dane osobowe */}
                    <h3><strong> Dane osobowe</strong> </h3>
                    <div className="contratRow">
                    <div className="contratColumn">
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">Imię i nazwisko:</span>
                        <span className="generated-contract__value">
                            {`${users.firstName}`}&nbsp;{`${users.lastName}`}
                        </span>
                    </p>
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">Adres:</span>
                        <span className="generated-contract__value">
                            {users.postalCode}&nbsp;{users.city + ','}&nbsp;{users.street}&nbsp;{users.building}{users.flat? '/': ''}{users.flat} 
                        </span>
                    </p>
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">E-mail:</span>
                        <span className="generated-contract__value">{users.email}</span>
                    </p></div>
                    <div className="contratColumn">
                    <p className="generated-contract__row marginAutoBottom">
                        <span className="generated-contract__property">PESEL:</span>
                        <span className="generated-contract__value">{users.pesel}</span>
                    </p>
                    <p className="generated-contract__row">
                                <span className="generated-contract__property">{" "}</span>
                                <span className="generated-contract__value">
                                {" "}
                                </span>
                            </p>
                    <p className="generated-contract__row marginAutoTop">
                        <span className="generated-contract__property">Telefon:</span>
                        <span className="generated-contract__value">{users.phone}</span>
                    </p>
                    </div></div>
                    
                </div>

                <div className="partPdf">
                    {/* Dane uczestnika */}
                    <h3><strong>
                        Dane uczestnika{' '}
                        <span>
                            (jeżeli inne niż powyżej lub uczestnik jest osobą niepełnoletnią)
                        </span></strong>
                    </h3>
                    <div className="contratRow">
                    <div className="contratColumn">
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">Imię i nazwisko:</span>
                        <span className="generated-contract__value">
                            {`${usersParticipant != "undefined"&&usersParticipant.length!=0? usersParticipant.firstName : '-'}`}&nbsp;
                            {`${usersParticipant != "undefined"&&usersParticipant.length!=0? usersParticipant.lastName : ''}`}
                        </span>
                    </p>
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">Adres:</span>
                        <span className="generated-contract__value">
                 
                            {usersParticipant != "undefined"&&usersParticipant.length!=0? usersParticipant.postalCode : '-'}&nbsp;
                            {usersParticipant != "undefined"&&usersParticipant.length!=0? usersParticipant.city + ',': ''}&nbsp;
                            {usersParticipant != "undefined"&&usersParticipant.length!=0? usersParticipant.street : ''}&nbsp;
                            {usersParticipant != "undefined"&&usersParticipant.length!=0? usersParticipant.building : ''}{usersParticipant? (usersParticipant.flat? '/': ''): ''} 
                            {usersParticipant != "undefined"&&usersParticipant.length!=0? usersParticipant.flat: ''} 
                        </span>
                    </p>
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">E-mail:</span>
                        <span className="generated-contract__value">
                            {usersParticipant != "undefined"&&usersParticipant.length!=0? usersParticipant.email : '-'}
                        </span>
                    </p>
                    </div>
                    <div className="contratColumn">
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">PESEL:</span>
                        <span className="generated-contract__value">
                            {usersParticipant != "undefined"&&usersParticipant.length!=0? usersParticipant.pesel : '-'}
                        </span>
                    </p>
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">Data urodzenia:</span>
                        <span className="generated-contract__value">
                             {usersParticipant != "undefined"&&usersParticipant.length!=0? usersParticipant.dateOfBirdth.split(" ")[0].replaceAll("/",".") : '-'}
                        </span>
                    </p>
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">Telefon:</span>
                        <span className="generated-contract__value">
                            {usersParticipant != "undefined"&&usersParticipant.length!=0? usersParticipant.phone : '-'}
                        </span>
                    </p>
                   
                    </div></div>
                    <div className="generated-contract__line"></div>
                </div>

                <div className="partPdf">
                    {/* Szczegóły umowy */}
                    <h3><strong>Szczegóły umowy</strong></h3>
                    <div className="contratRow">
                    <div className="contratColumn">
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">Rodzaj umowy:</span>
                        <span className="generated-contract__value">
                        {ready?getGroup: paymentsMetod(getGroup) }
                        </span>
                    </p><p className="generated-contract__row">
                        <span className="generated-contract__property">Długość zajęć:</span>
                        <span className="generated-contract__value">
                        {coursesHeadings.DurationMin} min.
                        </span>
                    </p>
                   <p className="generated-contract__row">
                        <span className="generated-contract__property">Data rozpoczęcia:</span>
                        <span className="generated-contract__value">
                        {replaceFormatData(dateToBay)}
                        </span>
                    </p>
                    </div>
                    <div className="contratColumn">
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">Data zakończenia:</span>
                        <span className="generated-contract__value">
                        {ready?replaceFormatData(coursesHeadings.closingDate):allInstallments[(allInstallments.length)-1].periodToDate}
                        </span>
                    </p>
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">Symbol (nazwa grupy):</span>
                        <span className="generated-contract__value">
                        {coursesHeadings.courseHeadingName
                                    ? coursesHeadings.courseHeadingName
                                    : ''}
                        </span>
                    </p>
                    <p className="generated-contract__row">
                        <span className="generated-contract__property">Ilość zajęć w tygodniu:</span>
                        <span className="generated-contract__value">
                        {coursesHeadings.Frequency}
                        </span>
                    </p>
                    </div></div>
                 

                    
                    <div className="generated-contract__line"></div>
                </div>

                <div className="partPdf">
                    {/* Szczegóły płatności */}
                    <h3><strong>Szczegóły płatności</strong></h3>
                    <div className="contratRow">
                        <div className="contratColumn">
                            <p className="generated-contract__row">
                                <span className="generated-contract__property">Koszt kursu:</span>
                                <span className="generated-contract__value">
                                {ConvertNumber(allInstallmentsPrice)} zł
                                </span>
                            </p>
                            <p className="generated-contract__row">
                                <span className="generated-contract__property">Płatność:</span>
                                <span className="generated-contract__value">
                                {ready?payForm:perioridOFPayment(getGroup)}
                                </span>
                            </p>
                            <p className="generated-contract__row">
                                <span className="generated-contract__property">Ilość pełnych rat:</span>
                                <span className="generated-contract__value">
                                {numberOfinstallments}
                                </span>
                            </p>
                            <p className="generated-contract__row">
                                <span className="generated-contract__property">Wartość raty miesięcznej: </span>
                                <span className="generated-contract__value">
                                {ConvertNumber(payZero.monthInstalment)} zł
                                </span>
                            </p>
                        </div>
                        <div className="contratColumn">
                            <p className="generated-contract__row">
                                <span className="generated-contract__property">{" "}</span>
                                <span className="generated-contract__value">
                                {" "}
                                </span>
                            </p>
                            <p className="generated-contract__row">
                                <span className="generated-contract__property">Opłata wpisowa: </span>
                                <span className="generated-contract__value">
                                {ConvertNumber(
                                    entryFee.priceDiscount != null?entryFee.priceDiscount:"0"
                                )}{' '}
                                zł
                                </span>
                            </p>
                            <p className="generated-contract__row">
                                <span className="generated-contract__property">Wartość pro-raty: </span>
                                <span className="generated-contract__value">
                                {ConvertNumber(payZero.installmentZero)} zł
                                </span>
                            </p>
                            <p className="generated-contract__row">
                                <span className="generated-contract__property">Suma opłat początkowych: </span>
                                <span className="generated-contract__value">
                                { payZero.amountZero} zł
                                </span>
                            </p>
                        </div>
                    </div>
                    
                    <div className="generated-contract__line"></div>
                </div>

                {/* <div className="partPdf">
                   Table caption 
                    <p className="generated-contract__row generated-contract__table-caption">
                        Wartość rat miesięcznych:
                    </p>
                     Table 
                    <table className="generated-contract__table">
                    {promotionsData.length > 0 ? 
                        <thead>
                            <tr>
                                <th>Nr raty</th>
                                <th>Kwota</th>
                                {/* <th>Rabat procentowy</th>
                                <th>Rabat kwotowy</th>
                                <th>Kwota po rabatach</th> 
                                <th>Termin płatności</th>
                            </tr>
                        </thead> : 
                        <thead>
                            <tr>
                                <th>Nr raty</th>
                                <th>Kwota</th>
                                <th>Termin płatności</th>
                            </tr>
                        </thead>} 
                        
                        <tbody>
                            {res.map((el) =>
                               
                                (el.paymentPositionPrice > 0 || el.discountProcent == 100) ? (
                                    
                                    <SingleContractInstallment
                                        key={el.countNumber}
                                        countNumber={el.countNumber}
                                        paymentPositionPrice={el.paymentPositionPrice}
                                        paymentMonth={el.paymentMonth}
                                        paymentDate={el.paymentDate}
                                        discountProcent={el.discountProcent}
                                        discountCash={el.discountCash}
                                        paymentPositionPriceDiscount={el.paymentPositionPriceDiscount}
                                        promotionsData={ promotionsData.length }
                                    />
                                ) : (
                                    ''
                                )
                            )}
                            {/* <SingleContractInstallment key={1} countNumber={1} paymentPositionPrice={222} paymentMonth={"wrzesień"} paymentDate={"2021-09-12"} />
                            <SingleContractInstallment key={1} countNumber={1} paymentPositionPrice={222} paymentMonth={"wrzesień"} paymentDate={"2021-09-12"} />
                            <SingleContractInstallment key={1} countNumber={1} paymentPositionPrice={222} paymentMonth={"wrzesień"} paymentDate={"2021-09-12"} />
                            <SingleContractInstallment key={1} countNumber={1} paymentPositionPrice={222} paymentMonth={"wrzesień"} paymentDate={"2021-09-12"} /> 
                        </tbody>
                    </table>
                </div> */}

                {/* Dalsza treść umowy */}
                <div className="generated-contract__clauses">
                    <div className="partPdf">
                        <h3><strong>1. Postanowienia ogólne</strong></h3>
                        <p>
                            1.1.	Częścią niniejszej Umowy jest <strong>Regulamin</strong> oraz <strong>Statut EDS</strong>, które są dostępne w placówce EDS. Regulamin i Statut stanowią załącznik nr 1 do niniejszej umowy. W przypadku zmiany Regulaminu lub Statutu EDS z ważnych przyczyn Klient otrzyma nową wersję dokumentu na wskazany przez siebie adres e-mail z co najmniej 14-dniowym wyprzedzeniem z prawem do rozwiązania Umowy z dniem poprzedzającym dzień wejścia w życie nowego brzmienia Regulaminu lub Statutu EDS.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            1.2. Wszelkie pojęcia zawarte w niniejszej Umowie mają znaczenie nadane
                            im przez <strong>Regulamin</strong>.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            1.3. Klient oświadcza, że nie istnieją żadne przeciwwskazania, w tym
                            zdrowotne, do uczestnictwa w zajęciach Grupy będącej przedmiotem
                            niniejszej Umowy.
                        </p>
                    </div>

                    <div className="partPdf">
                        <h3><strong>2. Przedmiot umowy</strong></h3>
                        <p>
                            2.1.	EDS zobowiązuje się świadczyć na rzecz Uczestnika usługi nauki tańca oraz/lub nauki choreografii, zgodnie z celami i zadaniami zawartymi w Statucie, na zajęciach prowadzonych w Grupie, zgodnie z postanowieniami niniejszej Umowy. Usługi nauki tańca oraz/lub nauki choreografii będą prowadzone zgodnie z autorskim programem opracowanym przez EDS, z którym Uczestnik się zapoznał i który w każdej chwili jest dostępny do wglądu w siedzibie EDS. 
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                        2.2.	Zajęcia Grupy, będące przedmiotem Umowy, są prowadzone zgodnie z harmonogramem dostępnym w placówce EDS, z wyłączeniem dni ustawowo wolnych od pracy, ferii zimowych oraz wakacji letnich. Harmonogram stanowi załącznik nr 2 do niniejszej umowy.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                        2.3.	Za zgodą EDS, Uczestnik może zmienić Grupę w trakcie obowiązywania Umowy na inną z oferty Zajęć regularnych o tej samej długości i częstotliwości, pod warunkiem dostępności miejsca w danej Grupie. Po potwierdzeniu dostępności miejsca w innej Grupie Uczestnik zobowiązany jest złożyć w recepcji EDS osobiście podpisany formularz aktualizacji danych. Zmiana grupy nie wymaga zmiany umowy w trybie punktu 5.2.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                        2.4.	Strony przewidują możliwość odrabiania Zajęć w ciągu 30 dni od daty Zajęć, w których Uczestnik nie mógł uczestniczyć, na innych Zajęciach z oferty otwartych Zajęć regularnych, o tej samej długości, pod warunkiem dostępności miejsca w danej Grupie i po uprzedniej akceptacji Managera EDS.
                        </p>
                    </div>
                    <div className="partPdf">
                        <p>
                        2.5.	Klient oświadcza, iż w przypadku wprowadzenia przez władze stosownych przepisów regulujących reżim przeprowadzania zajęć objętych niniejszą umową w związku z obowiązywaniem stanu zagrożenia epidemicznego lub stanu epidemii na obszarze Polski, zobowiązuje się on osobiście lub  w imieniu Uczestnika, którego jest opiekunem prawnym do każdorazowego podporządkowania się wprowadzonym w EDS procedurom związanym z tymi przepisami.
                        </p>
                    </div>
                    <div className="partPdf">
                        <h3><strong>3. Czas trwania umowy</strong></h3>
                        <p>
                        3.1.	Umowa zostaje zawarta na czas określony do dnia zakończenia umowy wskazanej w części wstępnej.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                        3.2.	Klient ma prawo wypowiedzenia niniejszej Umowy w dowolnym momencie z zachowaniem dwumiesięcznego okresu wypowiedzenia, a w przypadku zajęć dla 3-latków oraz zajęć dla par – z zachowaniem jednomiesięcznego okresu wypowiedzenia, ze skutkiem na koniec miesiąca kalendarzowego. Oświadczenie o wypowiedzeniu należy złożyć w formie pisemnej pod rygorem nieważności osobiście w placówce EDS lub drogą pocztową (liczy się data stempla pocztowego). Umowa ulega rozwiązaniu po upływie ostatniego dnia wypowiedzenia. 
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                        3.3.	Klientowi, który wypowiedział Umowę przysługuje w terminie 14 dni od dnia zakończenia Umowy zwrot uiszczonych, a niewykorzystanych opłat za Zajęcia pozostałe do końca okresu, do którego miała trwać Umowa.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                        3.4.	EDS ma prawo rozwiązania niniejszej Umowy ze skutkiem natychmiastowym, w przypadku, gdy: 
                        </p>
                    </div>
                    <div className="partPdf">
                        <p className="pargrafMarginLeft">•	nie została wniesiona opłata za udział w zajęciach na warunkach określonych w Umowie</p>

                        <p className="pargrafMarginLeft">•	mimo upomnienia Uczestnik nie stosuje się do obowiązujących regulacji wewnętrznych, w tym Regulaminu, właściwego Statutu, przepisów bhp i p-poż,</p>
                        <p className="pargrafMarginLeft">•	w toku zgłoszenia Klient lub Uczestnik utajnił problemy (w tym zdrowotne), które uniemożliwiają mu uczestnictwo w nauce tańca,</p>
                        <p className="pargrafMarginLeft">•	Uczestnik stosuje przemoc psychiczną lub fizyczną w stosunku do innych Uczestników zajęć lub Instruktora,</p>
                        <p className="pargrafMarginLeft">•	Uczestnik przebywa na terenie siedziby EDS lub w miejscu prowadzenia zajęć pod wpływem środków odurzających lub rozpowszechnia ww. środki na terenie siedziby EDS lub w miejscu prowadzenia zajęć,</p>
                        <p className="pargrafMarginLeft">•	Uczestnik dopuszcza się wandalizmu, niszczenia sprzętu na terenie siedziby EDS lub w miejscu prowadzenia zajęć,</p>
                        <p className="pargrafMarginLeft">•	poprzez swoje nieodpowiednie zachowanie Uczestnik uniemożliwia prowadzenia zajęć w Grupie,</p>
                        <p className="pargrafMarginLeft">•	Uczestnik swoim zachowaniem narusza zasady współżycia społecznego i dobrych obyczajów oraz nie podejmuje współpracy celem rozwiązania problemu.</p>
                    </div>

                    <div className="partPdf">
                        <p>
                        3.5.	W przypadku nie przestrzegania postanowień Umowy, <strong>Regulaminu</strong> lub <strong>Statutu</strong> przez Klienta lub Uczestnika (w przypadku, gdy Uczestnikiem jest osoba małoletnia), EDS może rozwiązać Umowę ze skutkiem natychmiastowym. Rozwiązanie powinno zawierać uzasadnienie. 
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            3.6.	Rozwiązanie umowy jest jednoznaczne ze skreśleniem Uczestnika z listy Uczestników EDS.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                        3.7.	Od decyzji w przedmiocie skreślenia z listy Uczestników można wnieść odwołanie do organu prowadzącego placówkę EDS na zasadach i w trybie określonym w <strong>Statucie</strong>.
                        </p>
                    </div>
                    <div className="partPdf">
                        <p>
                        3.8.	W zakresie rozliczeń związanych z rozwiązaniem Umowy stosuje się odpowiednio zasady określone w <strong>Regulaminie</strong>.
                        </p>
                    </div>
                    <div className="partPdf">
                        <p>
                        3.9.	Faktyczne zaprzestanie uczestnictwa w Zajęciach nie jest równoczesne rozwiązaniem niniejszej Umowy. Klient ma obowiązek uiszczania płatności za Zajęcia, które odbyły się do chwili rozwiązania Umowy.
                        </p>
                    </div>
                    <div className="partPdf">
                        <p>
                        3.10.	Nieobecność na Zajęciach nie zwalania z obowiązku uiszczenia opłaty.
                        </p>
                    </div>
                    <div className="partPdf">
                        <p>
                        3.11.	Klient oświadcza, że posiada i będzie posiadał środki finansowe na pokrycie należności określonych w niniejszej Umowie i że będzie regulował je terminowo.
                        </p>
                    </div>

                    <div className="partPdf">
                        <h3><strong>4. Opłaty</strong></h3>
                        <p>
                            4.1. Klient zobowiązuje się do opłacania rat oraz innych opłat w
                            wysokości i terminach określonych w niniejszej Umowie.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            4.2. Jednorazową opłatę wpisową oraz pro ratę należy uiścić przed
                            rozpoczęciem zajęć.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            4.3.	Klient może wybrać jeden z następujących sposobów uiszczenia opłat:
                        </p>
                    </div>
                    <div className="partPdf">
                        <p className="pargrafMarginLeft">a)	przedpłatą za całość kursu, w terminie do 5 dnia miesiąca, w którym zaczynają się Zajęcia Grupy, jednak nie później niż w dniu rozpoczęcia Zajęć Grupy,</p>

                        <p className="pargrafMarginLeft">b)	w formie miesięcznych rat płatnych do 5 dnia każdego kolejnego miesiąca obowiązywania umowy począwszy od pierwszego miesiąca, w którym mają mieć miejsce Zajęć Grupy, jednak nie później niż w dniu rozpoczęcia Zajęć Grupy w danym miesiącu.</p>
                     </div> 
                     <div className="partPdf">
                        <p>
                            sposób uiszczenia opłat Klient określa najpóźniej z chwilą dokonania pierwszej płatności.
                        </p>
                    </div>
                    <div className="partPdf">
                        <p>
                        4.4.	Pro-rata jest ustalana w wysokości proporcjonalnej do ilości Zajęć Grupy w pierwszym miesiącu kalendarzowym trwania umowy.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            4.5.	Terminowe dokonanie płatności jest warunkiem uczestnictwa w Zajęciach Grupy.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            4.6.	Wysokość raty wyliczana jest na podstawie całkowitej wartości kursu oraz miesięcy pozostających do jego zakończenia. Jest ona stała przez cały okres umowy, niezależnie od ilości Zajęć Grupy w danym miesiącu.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            4.7.	Dniem dokonania płatności jest data uznania rachunku bankowego EDS.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                        4.8.	Płatności przelewem należy wykonywać na rachunek bankowy: {coursesHeadings.banckAccountNumber}. W tytule należy podać imię i nazwisko Uczestnika oraz symbol Grupy, za które opłata jest wnoszona.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                        4.9.	Szczegółowe formy płatności akceptowane przez EDS określone są w <strong>Regulaminie</strong>.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                        4.10.	W okresie wypowiedzenia Klient ma obowiązek regulowania wszystkich należnych rat oraz opłat zgodnie z postanowieniami niniejszej umowy.
                        </p>
                    </div>

                    <div className="partPdf">
                        <h3><strong>    5.	POSTANOWIENIA   KOŃCOWE</strong></h3>
                        <p>
                            5.1	Klient oświadcza, że żąda od EDS rozpoczęcia świadczenia usług zgodnie z niniejszą Umową przed terminem przysługującego Klientowi prawa do odstąpienia od Umowy. Klient oświadcza, że został poinformowany przez EDS o treści art. 35 Ustawy z dnia 30 maja 2014 r. o prawach konsumenta (t.j. Dz. U. z 2020 r., poz. 287 ze zm.), zgodnie z którym Klient zobowiązany jest do zapłaty za świadczenia spełnione do chwili odstąpienia od umowy, a kwota obliczona zostanie proporcjonalnie do zakresu spełnionego świadczenia.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                        5.2	Niniejsza Umowa została sporządzona w dwóch, jednobrzmiących egzemplarzach, po jednym dla każdej ze Stron.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                        5.3	Zmiana niniejszej Umowy wymaga zachowania formy pisemnej pod rygorem nieważności.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                        5.4	W sprawach nieuregulowanych w niniejszej umowue stosuje się przepisy powszechnie obowiązujące.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                        5.5	Wszelkie spory związane z niniejszą umową będą rozstrzygane przez Sąd właściwy dla siedziby EDS.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                        5.6	Umowa zostaje zawarta z dniem podpisania przez obie Strony.
                        </p>
                    </div>
                    <div className="partPdf">
                        <p>
                        5.7	Załączniki:
                        </p>
                    </div>
                    <div className="partPdf">
                        <p>
                        - Załącznik nr 1 – Regulamin i Statut EDS,
                        </p>
                    </div>
                    <div className="partPdf">
                        <p>
                        - Załącznik nr 2 – Harmonogram
                        </p>
                    </div>
                    <div className="partPdf">
                        <h3><strong> 6.	KLAUZULA INFORMACYJNA RODO</strong> </h3>
                        <p>
                            6.1.	Administratorem Państwa danych osobowych w rozumieniu RODO jest EGURROLA DANCE STUDIO – Agustin Marek Egurrola z siedzibą w Warszawie, adres: ul. Żwirki i Wigury 99a, 02-089 Warszawa, NIP: 5251340026, REGON: 016098446.
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                            6.2.	W sprawach dotyczących przetwarzania Państwa danych osobowych można skontaktować się na adres korespondencyjny Administratora wskazany powyżej lub za pośrednictwem adresu e-mail: ido@egurrola.pl
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>6.3.	Twoje dane osobowe mogą być przetwarzane przez Administratora na podstawie: </p>
                    </div>
                    <div className="partPdf">
                        <p className="pargrafMarginLeft">•	niezbędności do zawarcia i wykonania umowy lub do podjęcia działań przed jej zawarciem (art. 6 ust. 1 lit. b RODO) oraz umożliwienia Tobie zapisu na newslettery oferowane przez Administratora;</p>

                        <p className="pargrafMarginLeft">•	w celu wypełnienia obowiązku prawnego ciążącego na Administratorze (art. 6 ust. 1 lit. c RODO);</p>
                        <p className="pargrafMarginLeft">•	prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) w celu: </p>
                        <p className="pargrafMarginLeft">
                      
                                <p className="pargrafMarginLeft">•	umożliwienia Tobie kontaktu z Administratorem za pośrednictwem Serwisu;</p>

                                <p className="pargrafMarginLeft">•	marketingu produktów i usług własnych Administratora, w tym w celach analitycznych i statystycznych (uzasadniony interes Administratora polegający na prowadzeniu analiz aktywności użytkowników, a także ich preferencji w celu prowadzenia marketingu produktów i usług własnych Administratora); </p>
                                <p className="pargrafMarginLeft">•	korzystanie z formularzy kontaktowych udostępnionych przez Administratora w Serwisie (uzasadniony interes Administratora polegający na opiece nad użytkownikami Serwisu i poprawy stosowanych funkcjonalności i świadczonych usług);</p>
                                <p className="pargrafMarginLeft">•	obrony przed ewentualnymi roszczeniami dochodzonymi przez Administratora lub od Administratora.</p>
                                
                        </p>
                    </div>
                    <div className="partPdf">
                        
                        <p>
                        6.4.	Administrator może przekazywać dane pomiotom przetwarzającym je na zlecenie Administratora i na podstawie zawartych umów, wyłącznie w celu i zakresie niezbędnym dla realizacji celów wskazanych w pkt 2 powyżej (m.in. na rzecz podmiotów świadczących usługi informatyczne, w tym zapewniające prawidłowe funkcjonowanie Serwisu), z zastrzeżeniem, że dane osobowe przetwarzane będą zgodnie z zaleceniami Administratora. Administrator przekaże dane osobowe jeżeli taki obowiązek będzie wynikać z bezwzględnie obowiązujących przepisów prawa, w szczególności uprawnionym organom państwowym. 
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                        6.5.	Administrator dokłada wszelkich starań aby Twoje dane osobowe przetwarzane były w sposób adekwatny i tak długo jak jest to niezbędne do celów, w jakich zostały one zebrane lub dopóki jest to wymagane przepisami prawa powszechnie obowiązującego, w szczególności do momentu przedawnienia ewentualnych roszczeń lub wygaśnięcia obowiązku archiwizacji. 
                        </p>
                    </div>

                    <div className="partPdf">
                        <p>
                        6.6.	W zakresie dozwolonym przez RODO przysługują Tobie Państwu następujące prawa w odniesieniu do Twoich danych osobowych:
                        </p>
                    </div>
                </div>
                <div className="partPdf">
                        <p className="pargrafMarginLeft">•	prawo dostępu do danych osobowych - w każdym czasie możesz skorzystać z prawa dostępu do swoich danych, w tym kopię tych danych. </p>

                        <p className="pargrafMarginLeft">•	prawo do sprostowania i uzupełnienia danych – Masz prawo żądania sprostowania Twoich danych osobowych, które są nieprawidłowe a także żądania uzupełnienia niekompletnych danych osobowych. </p>
                        <p className="pargrafMarginLeft">•	prawo do usunięcia danych –  Masz prawo do żądania niezwłocznego usunięcia Twoich danych osobowych przechowywanych przez Administratora w przypadkach, gdy:</p>
                        <p className="pargrafMarginLeft">
                      
                                <p className="pargrafMarginLeft">•	Twoje dane osobowe nie są już niezbędne do celów, w których zostały zebrane, </p>

                                <p className="pargrafMarginLeft">•	cofnąłeś zgodę, na której opiera się przetwarzanie i nie ma innej podstawy prawnej przetwarzania,  </p>
                                <p className="pargrafMarginLeft">•	wniesiesz sprzeciw wobec przetwarzania Twoich danych i nie występują nadrzędne prawnie uzasadnione podstawy przetwarzania,</p>
                                <p className="pargrafMarginLeft">•	przetwarzanie danych następuje niezgodnie z prawem, </p>
                                
                                <p className="pargrafMarginLeft">•	konieczność usunięcia Twoich danych wynika z wywiązania się z obowiązku prawnego przewidzianego w prawie Unii Europejskiej lub prawie polskim, </p>
                                <p className="pargrafMarginLeft">•	Twoje dane osobowe zostały zebrane w związku z oferowaniem usług społeczeństwa informacyjnego w rozumieniu RODO,  </p>
                        </p>
                    </div>
                    <div className="partPdf">
                        <p>
                        Jednakże Administrator nie będzie mógł usunąć Twoich danych osobowych w zakresie w jakim ich przetwarzanie będzie niezbędne do: 
                        </p>
                    </div>
                    <div className="partPdf">

                    <p className="pargrafMarginLeft">
                      
                      <p className="pargrafMarginLeft">•	korzystania z prawa do wolności wypowiedzi i informacji,  </p>

                      <p className="pargrafMarginLeft">•	wywiązana się z prawnego obowiązku wymagającego przetwarzania danych na mocy prawa Unii Europejskiej lub prawa polskiego,   </p>
                      <p className="pargrafMarginLeft">•	ustalenia, dochodzenia lub obrony roszczeń.</p>

                    </p>

                        <p className="pargrafMarginLeft">•	prawo do przenoszenia danych osobowych – W zakresie, w jakim Twoje dane są przetwarzane w celu zawarcia i wykonywania umowy lub przetwarzane na podstawie zgody oraz przetwarzanie danych odbywa się w sposób zautomatyzowany – masz prawo otrzymać od nas w ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego swoje dane osobowe, które dostarczyłeś przed lub w trakcie współpracy z nami. Masz także prawo przesłać te dane osobowe innemu administratorowi, o ile będzie to możliwe technicznie.  </p>

                        <p className="pargrafMarginLeft">•	prawo do ograniczenia przetwarzania danych – Masz prawo żądania ograniczenia przetwarzania danych w przypadkach, gdy: </p>
                        <p className="pargrafMarginLeft">
                             <p className="pargrafMarginLeft">•	kwestionujesz prawidłowość danych osobowych – na okres pozwalający nam sprawdzić prawidłowość tych danych,</p>
                             <p className="pargrafMarginLeft">•	przetwarzanie jest niezgodne z prawem i sprzeciwiasz się usunięciu danych osobowych, żądając w zamian ograniczenia ich wykorzystywania;</p>
                             <p className="pargrafMarginLeft">•	nie potrzebujemy już danych osobowych do celów przetwarzania, ale są one potrzebne Tobie, do ustalenia, dochodzenia lub obrony roszczeń;</p>
                             <p className="pargrafMarginLeft">•	wniosłeś sprzeciw wobec przetwarzania – do czasu stwierdzenia, czy prawnie uzasadnione podstawy po stronie Administratora są nadrzędne wobec podstaw Twojego sprzeciwu. </p>
                        </p>
                        <p className="pargrafMarginLeft">•	prawo do wniesienia sprzeciwu wobec przetwarzania danych osobowych – Jeżeli Twoje dane osobowe są przetwarzane na podstawie prawnie uzasadnionego interesu Administratora, masz prawo do sprzeciwu w dowolnym czasie wobec przetwarzania. Administrator może nie uwzględnić sprzeciwu jeśli wykaże on istnienie ważnych prawnie uzasadnionych podstaw do przetwarzania, nadrzędnych wobec Twoich interesów, praw i wolności, lub podstaw do ustalenia, dochodzenia lub obrony roszczeń.  </p> 
                    
                        <p className="pargrafMarginLeft">•	prawo do cofnięcia zgody – W zakresie w jakim przetwarzanie Twoich danych osobowych następuje w oparciu o Twoją zgodę, masz prawo do cofnięcia zgody w dowolnym momencie. Cofnięcie zgody pozostaje bez wpływu na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej cofnięciem.</p>
                        <p className="pargrafMarginLeft">•	prawo do skargi – Masz prawo wniesienia skargi na przetwarzanie danych osobowych przez Administratora do organu nadzorczego, którym jest w Polsce Prezes Urzędu Ochrony Danych Osobowych (adres: ul. Stawki 2, 00-193 Warszawa), jeżeli uznasz, że przetwarzanie Twoich danych osobowych jest niezgodne z prawem.</p>
                    
                    </div>
                    <div className="partPdf">
                        <p>
                        6.7.	W przypadku gdy będziesz chciał skorzystać z przysługujących Tobie praw prosimy o przesłanie do Administratora wiadomości na adres mailowy: ido@egurrola.pl lub pocztą tradycyjną na adres: ul. Żwirki i Wigury 99A, 02-089 Warszawa. Z prawa do złożenia skargi, o którym mowa w pkt 8) powyżej, można skorzystać kontaktując się bezpośrednio z organem nadzorczym (dane wskazane w pkt 8) powyżej). Twój wniosek/pismo powinno w miarę możliwości wskazywać czego dotyczy Twoje żądanie. 
                        </p>
                    </div>
                    <div className="partPdf">
                        <p>
                        6.8.	Bezpieczeństwo danych jest dla Administratora priorytetem i Administrator analizuje ryzyka w celu zapewnienia, że Twoje dane osobowe przetwarzane są w sposób bezpieczny, zapewniający przede wszystkim, że dostęp do danych mają jedynie osoby upoważnione i jedynie w zakresie, w jakim jest to niezbędne ze względu na wykonywane zadania. Administrator dba o to aby wszystkie operacje na danych osobowych były rejestrowane i dokonywane jedynie przez uprawnionych pracowników i współpracowników.
                        </p>
                    </div>
                    <div className="partPdf">
                        <p>
                        6.9.	Administrator podejmuje wszelkie niezbędne i zgodne z prawem działania, aby podmioty współpracujące z Administratorem (podwykonawcy i inne podmioty współpracujące) dawały gwarancję prawidłowego i odpowiedniego stosowania środków bezpieczeństwa w każdym przypadku przetwarzania Twoich danych osobowych wykonywanego na zlecenie Administratora. 
                        </p>
                    </div>
                    <div className="partPdf">
                        <p>
                        6.10.	Podanie przez Ciebie danych osobowych jest dobrowolne. Odmowa podania danych osobowych może jednak – w zależności od kontekstu, w którym dane te są przetwarzane – może uniemożliwić zawarcie umowy pomiędzy Tobą a Administratorem, jak również może wpłynąć na zakres usług, które Administrator będzie mógł świadczyć na Twoją rzecz lub może uniemożliwić kontakt z Tobą czy też przesłanie Tobie treści marketingowych.
                        </p>
                    </div>
                    <div className="partPdf">
                    {/* Agreement */}
                    <div className="generated-contract__agreement">
                        <div className="generated-contract__signatures">
                            <div className="generated-contract__signature">
                                <span>Data i podpis w imieniu EDS</span>
                            </div>
                            <div className="generated-contract__signature">
                                <span>Data i podpis Klienta</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="partPdf">
                    {/* Agreement */}
                    <div className="generated-contract_column__agreement">
                        <div className="generated-contract__signatures">
                        <p>Niniejszym oświadczam, iż zapoznałem/am się z Regulamin i akceptuję jego treść.</p> 
                            <div className="generated-contract__signature">
                                <span>Podpis Klienta</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="partPdf">
                    {/* Agreement */}
                    <div className="generated-contract_column__agreement">
                        <div className="generated-contract__signatures">
                        <p>Niniejszym oświadczam, iż zapoznałem/am się ze Statutem EDS<br/>i akceptuję jego treść.</p> 
                            <div className="generated-contract__signature">
                                <span>Podpis Klienta</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="partPdf">
                    {/* Agreement */}
                    <div className="generated-contract__agreement">
                        <div className="generated-contract__text">
                            <p>
                            Oświadczam, iż wyrażam nieodpłatną, nieograniczoną w czasie i co do terytorium zgodę EDS na utrwalanie wizerunku Uczestnika na zdjęciach i materiałach filmowych i jego wykorzystywanie, zgodnie z warunkami, o których mowa w Regulaminie stanowiącym Załącznik nr 1 do niniejszej Umowy.
                            </p>
                        
                        </div>
                    </div>
                </div>
                <div className="partPdf">
                    <div className="generated-contract__agreement">
                        <div className="generated-contract__signature--only-client">
                            <div className="generated-contract__signature">
                                <span>Podpis Klienta</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="partPdf">
                    {/* Agreement */}
                    <div className="generated-contract__agreement">
                        <div className="generated-contract__text">
                            <p>
                            Oświadczam, iż wyrażam nieodpłatną, nieograniczoną w czasie i co do terytorium zgodę EDS na utrwalanie wizerunku Uczestnika na zdjęciach i materiałach filmowych i jego wykorzystywanie, zgodnie z warunkami, o których mowa w Regulaminie stanowiącym Załącznik nr 1 do niniejszej Umowy.
                            </p>
                        
                        </div>
                    </div>
                </div>
                <div className="partPdf">
                    <div className="generated-contract__agreement">
                        <div className="generated-contract__signature--only-client">
                            <div className="generated-contract__signature">
                                <span>Podpis Klienta</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="partPdf">
                    {/* Agreement */}
                    <div className="generated-contract__agreement">
                        <div className="generated-contract__text">
                            <p>
                            Wyrażam zgodę na otrzymywanie informacji marketingowych i handlowych drogą elektroniczną na podany przeze mnie adres e-mail z użyciem telekomunikacyjnych urządzeń końcowych i automatycznych systemów wywołujących.
                            </p>
                        
                        </div>
                    </div>
                </div>
                <div className="partPdf">
                    <div className="generated-contract__agreement">
                        <div className="generated-contract__signature--only-client">
                            <div className="generated-contract__signature">
                                <span>Podpis Klienta</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="partPdf">
                    {/* Agreement */}
                    <div className="generated-contract__agreement">
                        <div className="generated-contract__text">
                            <p>
                            Wyrażam zgodę na otrzymywanie informacji marketingowych i handlowych drogą elektroniczną na podany przeze mnie numer telefonu z użyciem telekomunikacyjnych urządzeń końcowych i automatycznych systemów wywołujących.
                            </p>
                        
                        </div>
                    </div>
                </div>
                <div className="partPdf">
                    <div className="generated-contract__agreement">
                        <div className="generated-contract__signature--only-client">
                            <div className="generated-contract__signature">
                                <span>Podpis Klienta</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    ) : (
        ''
    );
};
export default AppContractsRefresh;
